/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import {fieldObjectSectionStyle} from "../../helpers/graphQLShortcuts";
import {fieldObjectSectionStyleCss} from "../../helpers/createStyles";
import {filterHeadline} from "../../helpers/filters";
import './QuoteCarouselAlt.scss';
import Paragraph from "../Paragraph";

class QuoteCarouselAltQuery extends Query<{id: string}> {}

const GET_COMPONENT = gql`
query paragraphById($id: String!) {
  paragraphById:paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphComponentQuoteCarousel {
          fieldObjectSectionStyle {
              ${fieldObjectSectionStyle}
          }
          fieldTxtHeadline
          fieldCarouselItems {
            targetRevisionId
          }
        }
      }
    }
  }
}
`;

// eslint-disable-next-line no-unused-vars
const QuoteCarouselAlt = ({id, markComponentLoadedAs, handleLoadedComponents}) => (
    <QuoteCarouselAltQuery asyncMode query={GET_COMPONENT} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error) {
                markComponentLoadedAs(id, true);
                return <div>{error}</div>;
            }

            const field = data.paragraphById;

            // Generate Styles Object
            const styles = fieldObjectSectionStyleCss(field.fieldObjectSectionStyle);
            const cssId = field && field.fieldObjectSectionStyle && field.fieldObjectSectionStyle.entity && field.fieldObjectSectionStyle.entity.fieldCssId ? field.fieldObjectSectionStyle.entity.fieldCssId : null;

            // Ensure Carousel Items Exist
            if (!(field && field.fieldCarouselItems && field.fieldCarouselItems.length)) return null;

            markComponentLoadedAs(id, true);

            return (

                <section className={`testimonialsCarousel testimonialsCarouselComponent${styles.classNames}`} style={styles.css} id={cssId}>

                    {styles.childBackground.isActive && (
                        <div className="generalContent__background" style={styles.childBackground.css}/>
                    )}

                    <div className="container">

                        {field.fieldTxtHeadline && (
                            // eslint-disable-next-line react/no-danger
                            <div className="testimonialsCarousel__header">
                                <h3 style={field.fieldHeadlineColor ? {color: field.fieldHeadlineColor} : null} dangerouslySetInnerHTML={{__html: filterHeadline(field.fieldTxtHeadline)}} />
                            </div>
                        )}

                        <div className="testimonialsCarousel__container">
                            <div className="testimonialsCarousel__carousel swiper">
                                <div className="testimonialsCarousel__wrapper swiper-wrapper">

                                    {field.fieldCarouselItems.map(item => (
                                        <Paragraph key={`${id}_${item.targetRevisionId}`}
                                                   id={String(item.targetRevisionId)}
                                                   handleLoadedComponents={handleLoadedComponents}/>
                                    ))}

                                </div>
                            </div>

                            <button className="swiper-button-prev testimonialsCarousel-swiper-button-prev"/>
                            <button className="swiper-button-next testimonialsCarousel-swiper-button-next"/>

                            <div className="swiper-pagination testimonialsCarousel-swiper-pagination"/>
                        </div>
                    </div>
                </section>
            );
        }}
    </QuoteCarouselAltQuery>
);

QuoteCarouselAlt.propTypes = {
    id: PropTypes.number.isRequired,
    markComponentLoadedAs: PropTypes.func.isRequired,
    handleLoadedComponents: PropTypes.func.isRequired
};

export default QuoteCarouselAlt;



// WEBPACK FOOTER //
// ./frontend/components/QuoteCarouselAlt/QuoteCarouselAlt.jsx